import axios, { AxiosError, AxiosResponse } from 'axios';

let refresh = false;

axios.interceptors.response.use(
  (resp: AxiosResponse) => resp,
  async (error: AxiosError) => {
    if (error.response?.status === 401 && !refresh) {
      refresh = true;

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_ADMIN_URL}/token/refresh/`,
          {
            refresh: localStorage.getItem('refresh_token'),
          },
          {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
          }
        );

        if (response.status === 200) {
          const accessToken = (response.data as any)['access'];
          axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
          localStorage.setItem('access_token', accessToken);
          localStorage.setItem('refresh_token', (response.data as any).refresh);
          return axios(error.config!);
        }
      } catch (refreshError) {
        refresh = false;
        return Promise.reject(refreshError);
      }
    }

    refresh = false;
    return Promise.reject(error);
  }
);
